import React, { useRef } from "react";
import { RATINGS_ENABLED } from "../../../lib/kitsBrowse";

// design doc section 7.1/12: the option list is driven by RATINGS_ENABLED so
// flipping that one flag adds/removes the "Best rated" segment and nothing
// else moves. `Name`, `BPM` and `Genre` are deliberately absent -- they are
// filters now (design section 14, pushback 1).
const OPTIONS = [
  { value: "newest", label: "Newest" },
  { value: "downloads", label: "Most downloaded" },
  ...(RATINGS_ENABLED ? [{ value: "rating", label: "Best rated" }] : []),
];

// Selected state is WHITE, never orange -- filters own orange, sort owns
// white, so the two families never look alike (design section 0/2).
export default function SortSegments({ sort, onChange }) {
  const btnRefs = useRef([]);

  const move = (delta) => {
    const idx = OPTIONS.findIndex((o) => o.value === sort);
    const nextIdx = (idx + delta + OPTIONS.length) % OPTIONS.length;
    onChange(OPTIONS[nextIdx].value);
    btnRefs.current[nextIdx]?.focus();
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
      e.preventDefault();
      move(1);
    } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
      e.preventDefault();
      move(-1);
    }
  };

  return (
    <div className="flex items-center gap-2 sm:gap-3 min-w-0">
      <span className="shrink-0 font-mono text-xs uppercase tracking-wider text-[#A1A1AA]">
        Sort
      </span>
      {/* At 375px, "SORT" + all 3 segments at their design-spec padding
          (px-3, gap-3) run a little past the 327px content column -- close
          enough that trimming padding/gap to px-2/gap-2 ONLY below `sm`
          closes the gap entirely; sm and up keep the exact spec values.
          min-w-0 + overflow-x-auto stays as a safety net regardless (never
          let the labels wrap mid-word, the way GenreChips falls back too). */}
      <div
        role="radiogroup"
        aria-label="Sort"
        onKeyDown={handleKeyDown}
        className="inline-flex min-w-0 max-w-full overflow-x-auto rounded border border-white/10 bg-[#1a1a1e] p-0.5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      >
        {OPTIONS.map((opt, i) => {
          const selected = sort === opt.value;
          return (
            <button
              key={opt.value}
              ref={(el) => (btnRefs.current[i] = el)}
              type="button"
              role="radio"
              aria-checked={selected}
              onClick={() => !selected && onChange(opt.value)}
              className={`h-8 shrink-0 whitespace-nowrap rounded-[3px] px-2 sm:px-3 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FF5500] focus-visible:ring-offset-2 focus-visible:ring-offset-[#050505] ${
                selected ? "bg-white/10 text-white" : "text-[#A1A1AA] hover:text-white"
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
